module.exports = __webpack_public_path__ + "img/delta-connections.a0149c81.png";